/**
 * Image Hotspots Block - Save Component
 *
 * Returns null because this is a dynamic block rendered via render.php.
 *
 * @package BrandyBlocks
 */

export default function Save() {
	return null;
}
